module.exports = __webpack_public_path__ + "static/media/ally_pro_web_2.ea560be7.jpg";